import { ActionableNotification } from '@carbon/react';
import { useTranslation } from '@pos/i18n';
import './AppUpdateNotice.scss';

export interface AppUpdateNoticeProps {
  /** A new version is downloaded and waiting (`useAppUpdate` from `@pos/offline`). */
  open: boolean;
  onReload: () => void;
  /** `bottom`: the POS toast place, above the command bar (DESIGN_SYSTEM.md §9.1); `top`: Carbon's, under the admin header. */
  placement?: 'bottom' | 'top';
}

/**
 * Says a new version of the app is ready (ARCHITECTURE.md, "Web apps"). The app changes only when the user taps Reload, so
 * nothing changes in the middle of an order; closed, the new version starts the next time the app is opened.
 */
export function AppUpdateNotice({ open, onReload, placement = 'bottom' }: AppUpdateNoticeProps) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <ActionableNotification
      className={`pos-app-update pos-app-update--${placement}`}
      kind="info"
      role="status"
      title={t('common.appUpdate.title')}
      subtitle={t('common.appUpdate.subtitle')}
      actionButtonLabel={t('common.appUpdate.reload')}
      onActionButtonClick={onReload}
      aria-label={t('carbon.close')}
    />
  );
}
